import { Alert, Stack } from '@mui/material'
import ContactDetailsSection from '../contacts/ContactDetailsSection'
import StepHeader from './StepHeader'

export const SENDER_NAMES_READ_ONLY_MESSAGE = 'רק משתמש עם הרשאה לניהול הגדרות המשרד יכול לשנות את שמות השולח.'

export const SENDER_NEXT_HINT = 'לחצו על הבא כדי לבחור פרטי קשר'

export const SENDER_HEADER = 'איזה שם תרצו שיופיע בשדה ״מאת״ בהודעה שהלקוח יקבל?'

export default function SendSenderStep({
    names,
    editable,
    selectableIds,
    selectedId,
    onSelect,
}) {
    const selectedIds = selectedId == null ? [] : [selectedId]

    const updateName = ({ id, ...input }) => names.update(id, input)

    return (
        <Stack spacing={2}>
            <StepHeader>{SENDER_HEADER}</StepHeader>

            {selectedId != null && (
                <Alert severity="info" data-testid="next-step-hint">{SENDER_NEXT_HINT}</Alert>
            )}

            {!editable &&<Alert severity="warning" data-testid="sender-read-only">{SENDER_NAMES_READ_ONLY_MESSAGE}</Alert>}

            <ContactDetailsSection
                details={names.items}
                onAdd={names.create}
                onUpdate={updateName}
                onRemove={names.remove}
                onRestore={names.restore}
                onConfirmRemoval={names.confirmRemoval}
                refusals={names.refusals}
                fixedType="name"
                reorderable={false}
                readOnly={!editable}
                selection={{
                    kind: 'radio',
                    selectedIds,
                    selectableIds,
                    onSelect,
                }}
            />
        </Stack>
    )
}
